import { styled } from '@linaria/react';

export const Spacer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1em;
`;
